import type { ReactNode } from 'react'
import { SampleCard } from '../sample-card/SampleCard'
import type { Sample } from '../../types/types'
import { EmptyState } from '../empty-state/EmptyState'

type SamplesCardListProps = {
  samples: Sample[]
  loaderContent?: ReactNode
  cardView?: 'compact' | 'expanded'
}

export function SamplesCardList({
  samples,
  loaderContent,
  cardView = 'expanded'
}: Readonly<SamplesCardListProps>) {
  if (samples.length === 0) {
    return (
      <EmptyState title='Ingen prøver' description='Ingen prøver å vise.' />
    )
  }

  return (
    <div className='grid gap-2'>
      {samples.map((sample) => (
        <SampleCard key={sample.id} sample={sample} view={cardView} />
      ))}
      {loaderContent}
    </div>
  )
}
